"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var SVGBox_1 = require("../SVGBox");
var themes_1 = require("../../../themes");
var RegularSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, size = _a.size, rest = __rest(_a, ["fill", "size"]);
    return (jsx_runtime_1.jsxs(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 24 24" }, rest, { children: [jsx_runtime_1.jsx("rect", { x: "0.5", y: "0.5", width: "23", height: "23", rx: "1.5", stroke: "black", strokeWidth: "1", fill: fill ? themes_1.THEME.colors.basic.White100 : 'transparent' }, void 0),
            jsx_runtime_1.jsx("circle", { cx: "8", cy: "7", r: "3", stroke: "black", strokeWidth: "1", fill: fill }, void 0),
            jsx_runtime_1.jsx("path", { d: "M0.5 22V21.1587L4.96381 14.835C5.51886 14.0486 6.66034 13.9811 7.30421 14.6965L9.24796 16.8563C9.91169 17.5937 11.0957 17.4952 11.6284 16.6581L16.3391 9.25551C16.9082 8.36126 18.2001 8.3233 18.8207 9.18259L23.5 15.6617V22C23.5 22.8284 22.8284 23.5 22 23.5H2C1.17157 23.5 0.5 22.8284 0.5 22Z", stroke: "black", strokeWidth: "1", fill: fill }, void 0)] }), void 0));
};
var BigSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, size = _a.size, rest = __rest(_a, ["fill", "size"]);
    return (jsx_runtime_1.jsxs(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 32 32" }, rest, { children: [jsx_runtime_1.jsx("rect", { x: "0.75", y: "0.75", width: "30.5", height: "30.5", rx: "1.92", stroke: "black", strokeWidth: "1.5", fill: fill ? themes_1.THEME.colors.basic.White100 : 'transparent' }, void 0),
            jsx_runtime_1.jsx("circle", { cx: "10.6667", cy: "9.33334", r: "4", stroke: "black", strokeWidth: "1.5" }, void 0),
            jsx_runtime_1.jsx("path", { d: "M0.75 29.33V27.9047L6.68409 19.4981C7.39455 18.4916 8.85564 18.4052 9.67979 19.3209L12.5621 22.5235C13.3365 23.3839 14.7179 23.2689 15.3393 22.2924L21.8532 12.0562C22.5816 10.9116 24.2352 10.863 25.0295 11.9629L31.25 20.5759V29.33C31.25 30.3904 30.3904 31.25 29.33 31.25H2.67C1.60961 31.25 0.75 30.3904 0.75 29.33Z", stroke: "black", strokeWidth: "1.5", fill: fill }, void 0)] }), void 0));
};
var ImageIcon = function (props) {
    var _a = props.size, size = _a === void 0 ? 24 : _a, rest = __rest(props, ["size"]);
    return size < 32 ? (jsx_runtime_1.jsx(RegularSizedIcon, __assign({ size: size }, rest), void 0)) : (jsx_runtime_1.jsx(BigSizedIcon, __assign({ size: size }, rest), void 0));
};
exports.ImageIcon = ImageIcon;
//# sourceMappingURL=ImageIcon.js.map